import React, { useEffect, useState } from 'react';
import {storage} from '@enigma/core/services';
import Stylesheet from './Video.module.css';
import Classnames from 'classnames';
import {ico_play, ico_pause, ico_redo_alt, 
    ico_volume_mute, ico_volume_up, ico_volume_down, 
    ico_step_forward, ico_closed_captioning, ico_expand_arrows_alt,
    ico_compress_arrows_alt} from '../../icon';
import { AppContext } from '../../contexts/app';

const Video = (props) => {
    const [playing, setPlaying] = useState(false);
    const [loading, setLoading] = useState(false);
    const [buffer, setBuffer] = useState( { lastPlayPos: 0 });
    const [bufferLisnter, setBufferLisnter] = useState(null)
    const [volume, setVolume] = useState(100);
    const [fullscreen, setFullscreen] = useState(false);
    // video refference
    let playerRef = React.createRef();
    let volumeRef = React.createRef();
    let app = null;
    useEffect(() => {
        // check if media changed
        if (props?.src) {
            setBufferLisnter(setInterval(checkBuffering, 50.0));
            onTogglePlayback();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])
    useEffect(() => {return function clearnup() {clearInterval(bufferLisnter)} })
    const init = (appContext) => app = appContext
    const onRewind = function() { playerRef.current.currentTime -= 10 }
    const onForward = function() { playerRef.current.currentTime += 10 }
    const onProgress = function(event) {}
    const onSubtitles = function() {}
    const onFullScreen = function() {setFullscreen(fullscreen ? false : true)}
    const toggleControls = function() {}
    const onPlaybackEnded = function() {setPlaying(false)};
    const onVolume = function() { 
        playerRef.current.volume = (volumeRef.current.value / 100);
        setVolume(volumeRef.current.value);
    }
    const checkBuffering = function() {
        let player = playerRef.current;
        let currentPlayPos = player.currentTime;
        // checking offset should be at most the check interval
        // but allow for some margin
        var offset = 0.03;
        // if no buffering is currently detected,
        // and the position does not seem to increase
        // and the player isn't manually paused...
        if (!loading  && currentPlayPos < (buffer.lastPlayPos + offset) 
            && !player.paused)
            if (!loading) setLoading(true);
        // if we were buffering but the player has advanced,
        // then there is no buffering
        if (loading && currentPlayPos > (buffer.lastPlayPos + offset) 
            && !player.paused) 
            if (loading) setLoading(false);
        setBuffer({lastPlayPos: currentPlayPos});
    }
    const onTogglePlayback = async function() {
        // get video player refference
        let videoPlayer = playerRef.current;
        // check if video is download from cloud storage
        if (props.src) {
            // set playback video
            if (!videoPlayer.src) {
                if (props.url === 'relative') {
                    //get media url from cloud storage
                    const url = await storage.getDownloadURL(props.src);
                    // stop loading animation
                    videoPlayer.src = url
                } else 
                    // static media
                    videoPlayer.src = props.src
            }
            //check if media is playing
            if (videoPlayer.paused) {
                setPlaying(true);
                videoPlayer.play();
            } else {
                setPlaying(false);
                videoPlayer.pause();
            }
        } else 
            app.toggleToast(ico_play, 'no media selected', true);
    }  
    const header = () => {
        if (!props.metadata) return <div className={Stylesheet.Header}></div>
        return (
            <div className={Stylesheet.Header}>
                <div className={Stylesheet.Metadata}>
                    <h4>{props.metadata.module.title}</h4>
                    <h5>section {props.metadata.section.index}
                    &nbsp;| module {props.metadata.module.index}</h5>
                </div>
                <div className={Stylesheet.Controls}>
                    <button>{ico_step_forward} next module</button>
                </div>
            </div>
        )
    }
    const overlay = () => {
        return (
            <div className={Stylesheet.Overlay}>
                <button onClick={onTogglePlayback}>
                    {playing ? ico_pause : ico_play}
                </button>
            </div>
        )
    }
    const footer = () => {
        let icon = null;
        if (volume > 50)
            icon = ico_volume_up;
        if (volume < 2)
            icon = ico_volume_mute;
        if (volume < 50)
            icon = ico_volume_down;
        return (
            <div className={Stylesheet.Footer}>
                <div className={Stylesheet.Seek}>
                    <div className={Stylesheet.Bar}></div>
                </div>
                <div className={Stylesheet.Controls}>
                    <div className={Stylesheet.Playback}>
                        <div className={Stylesheet.State}>
                            <div className={Stylesheet.Popover}>
                            <h5>{playing ? 'pause' : 'play'}</h5></div>
                            <button onClick={onTogglePlayback}>
                            {playing ? ico_pause : ico_play}</button>
                        </div>
                        <div className={Stylesheet.Rewind}>
                            <div className={Stylesheet.Popover}>
                            <h5>-10 Sec</h5></div>
                            <button onClick={onRewind}>{ico_redo_alt}</button>
                        </div>
                        <div className={Stylesheet.Forward}>
                            <div className={Stylesheet.Popover}>
                            <h5>+10 Sec</h5></div>
                            <button onClick={onForward}>{ico_redo_alt}</button>
                        </div>
                        <div className={Stylesheet.Volume}>
                            <div className={Stylesheet.Popover}>
                            <h5>{volume}</h5></div>
                            <h4>{icon}</h4>
                            <input type='range' min='0' max='100' ref={volumeRef}
                            onChange={onVolume} />
                        </div>
                    </div>
                    <div className={Stylesheet.Settings}>
                        <div className={Stylesheet.Subtitles}>
                            <div className={Stylesheet.Popover}>
                            <h5>Subtitles</h5></div>
                            <button onClick={onSubtitles}>
                            {ico_closed_captioning}</button>
                        </div>
                        <div className={Stylesheet.Fullscreen}>
                            <div className={Stylesheet.Popover}>
                            <h5>full screen</h5></div>
                            <button onClick={onFullScreen}>
                            {fullscreen 
                            ? ico_compress_arrows_alt
                            : ico_expand_arrows_alt}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    return(
        <AppContext.Consumer>
            {app => (
                <div className={Classnames(Stylesheet.Container,
                    {[Stylesheet['Buffering']]: loading && props.src}) }>
                    {init(app)}
                    <div className={Classnames(Stylesheet.Menu, {
                    [Stylesheet[playing ? 'Hidden' : 'Active']] : true})}>
                    {header}
                    {overlay}
                    {footer}</div>
                    <div className={Stylesheet.Loading}></div>
                    <video preload={props.preload} 
                    poster={props.poster} 
                    onEnded={onPlaybackEnded}
                    ref={playerRef}
                    onMouseDown={toggleControls}
                    src={null}
                    onProgress={onProgress}
                    onPause={_ => setPlaying(false)}
                    onPlay={_ => setPlaying(true)}>
                    </video>
                </div>
            )}
        </AppContext.Consumer>
    )
}

export default Video;
